import React from 'react';
import { useRecoilValue } from 'recoil';
import NumberInput from '../../../../common/input/NumberInput';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';
import useCalculatorForOtherBankCondition from '../../../../../hooks/estimate/common/otherBank/useCalculatorForOtherBankCondition';

/**
 *  타금융사 할부조건 할부원금 input 로직 컴포넌트
 *  */
function OtherBankInstallmentPrincipal(): JSX.Element {
  // selected
  // 할부원금
  const value: number = useRecoilValue(
    otherBankInfoState({ name: 'otherBankInstallmentPrincipal' })
  );

  // 원금 종류
  const type: string = useRecoilValue(otherBankInfoState({ name: 'otherBankPrincipalType' }));

  // function
  const { updateInstallment } = useCalculatorForOtherBankCondition();
  const onBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const installmentPrincipal: number = Number(e.target.value);
    updateInstallment({
      inputName: 'installmentPrincipal',
      inputValue: installmentPrincipal,
    });
  };

  return (
    <NumberInput
      width='80px'
      fontSize='10px'
      name='installmentPrincipal'
      disabled={type !== 'installmentPrincipal'}
      onBlur={onBlur}
      value={value}
    />
  );
}

export default OtherBankInstallmentPrincipal;
